"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TableBody_1 = require("@material-ui/core/TableBody");

var TableRow_1 = require("@material-ui/core/TableRow");

var React = require("react");

var utils_1 = require("../utils");

var NoDataRow_1 = require("./NoDataRow");

var getStyles = function getStyles(isPointer) {
  return {
    row: {
      cursor: isPointer ? 'pointer' : 'auto'
    },
    title: {
      paddingLeft: '15px'
    }
  };
};

exports.GridBody = function (_a) {
  var grid = _a.grid,
      bodyRenderer = _a.bodyRenderer,
      onRowClick = _a.onRowClick;

  var onRowClickProxy = function onRowClickProxy(row) {
    return function (ev) {
      if (onRowClick) {
        onRowClick(row);
      }
    };
  };

  var getStandardBodyRenderer = function getStandardBodyRenderer(row, rowIndex, columns) {
    return React.createElement(TableRow_1["default"], {
      hover: true,
      key: rowIndex,
      onClick: onRowClickProxy(row),
      style: styles.row
    }, utils_1.renderCells(columns, row));
  };

  var styles = getStyles(Boolean(onRowClick));

  if (!bodyRenderer) {
    bodyRenderer = getStandardBodyRenderer;
  }

  return React.createElement(TableBody_1["default"], null, grid.state.filteredRecordCount === 0 && !grid.state.isLoading ? React.createElement(NoDataRow_1.NoDataRow, {
    grid: grid,
    styles: styles
  }) : grid.state.data.map(function (row, rowIndex) {
    return bodyRenderer(row, rowIndex, grid.state.columns, onRowClickProxy(row));
  }));
};